module.exports = frontAdjuntos;